import { css } from 'styled-system/css';

export const pageTabBarStyle = {
	pageFilter: css({
		_mars: {
			_mdBelow: {
				bgColor: 'var(--s600)',
			},
			'& .tab__item': {
				rounded: '6px',
				border: '1px solid transparent',
				bgColor: 'white.3',
				color: 'black.2',
				'&[data-selected="true"]': {
					bgColor: 'var(--other-lv2)',
					color: 'brand.500_light',
					borderColor: 'brand.500_light',
				}
			}
		}
	}),
}